import type { SubSessionIdEventDetail } from './wireContract';
import { SUB_SESSION_ID_EVENT, SUB_SESSION_SPA_VARIABLE } from './wireContract';

/**
 * Announces this tab's sub-session id to same-document listeners. Also keeps
 * `spa_variables.subSessionId` current: IBE only sets it for the document, so it goes stale.
 */
export const announceSubSessionId = (subSessionId: string): void => {
  if (window.spa_variables) {
    window.spa_variables[SUB_SESSION_SPA_VARIABLE] = subSessionId;
  }

  window.dispatchEvent(
    new CustomEvent<SubSessionIdEventDetail>(SUB_SESSION_ID_EVENT, { detail: { subSessionId } }),
  );
};

// Clears `spa_variables.subSessionId` when it holds an id this tab gave up to another tab.
export const withdrawSubSessionId = (subSessionId: string): void => {
  if (window.spa_variables?.[SUB_SESSION_SPA_VARIABLE] === subSessionId) {
    delete window.spa_variables[SUB_SESSION_SPA_VARIABLE];
  }
};
